import PropTypes from "prop-types";

import CancelButton from "../../Actions/CancelButton";
import DeleteConfirmationButton from "../DeleteConfirmationButton";
import {
  deleteOverlayContainer,
  neverMindButtonCss,
} from "./AnnotationCommentDeleteActions.style";

const propTypes = {
  annotationId: PropTypes.number,
  commentDeleteConfirmationButtonRef: PropTypes.object,
  handleCancel: PropTypes.func,
  handleDelete: PropTypes.func,
  isActionPending: PropTypes.bool,
};

const AnnotationCommentDeleteActions = ({
  annotationId,
  commentDeleteConfirmationButtonRef,
  handleCancel,
  handleDelete,
  isActionPending,
}) => (
  <div css={deleteOverlayContainer}>
    <CancelButton
      annotationId={annotationId}
      buttonFlavor="solid"
      buttonStatusColor="white"
      handleCancel={handleCancel}
      __cssFor={{ root: neverMindButtonCss }}
    >
      Never mind
    </CancelButton>
    <DeleteConfirmationButton
      annotationId={annotationId}
      commentDeleteConfirmationButtonRef={commentDeleteConfirmationButtonRef}
      isActionPending={isActionPending}
      handleDelete={handleDelete}
    />
  </div>
);

AnnotationCommentDeleteActions.propTypes = propTypes;

export default AnnotationCommentDeleteActions;
